import { makeAutoObservable } from "mobx";

const STORAGE_KEY = "hp_sign_in";
const PROMPT_KEY = "hp_signin_prompt_dismissed";

/**
 * Sign-in is switched on for everyone by `VITE_SIGN_IN=true` (set in the CI workflow).
 * Without it, `?signin=1` turns it on in
 * this browser (remembered), and `?signin=0` turns it off again, so it can be tested in production.
 */
export const readSignInEnabled = (): boolean => {
    if (import.meta.env.VITE_SIGN_IN === "true") return true;
    if (typeof window === "undefined") return false;

    try {
        const requested = new URLSearchParams(window.location.search).get("signin");
        if (requested === "1") localStorage.setItem(STORAGE_KEY, "1");
        if (requested === "0") localStorage.removeItem(STORAGE_KEY);
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        // Storage can be blocked; sign-in then stays hidden
        return false;
    }
};

const readPromptDismissed = (): boolean => {
    try {
        return localStorage.getItem(PROMPT_KEY) === "1";
    } catch {
        return false;
    }
};

export class AppStore {
    showSignIn = false;
    signInEnabled = readSignInEnabled();
    /** The "log in to remember where you were" prompt was closed; a setting of the device, not personal data */
    signInPromptDismissed = readPromptDismissed();

    constructor() {
        makeAutoObservable(this);
    }

    setShowSignIn(show: boolean) {
        this.showSignIn = show;
    }

    dismissSignInPrompt() {
        this.signInPromptDismissed = true;
        try {
            localStorage.setItem(PROMPT_KEY, "1");
        } catch {
            // Blocked storage: the prompt then comes back on the next visit
        }
    }
}
